/**
 * Come si chiama un modello prestativo in interfaccia.
 *
 * Il modello di sistema ha un nome fisso e tradotto; quello di un coach ha il
 * nome che gli ha dato lui (dato utente: non si traduce) e il proprietario.
 */
export function modelTitle(model, t) {
	if (!model) return "";
	if (model.is_system) return t("scSystemModel");
	return model.name || t("scCoachModel");
}

export function modelOwnerText(model, t) {
	if (!model) return "";
	if (model.is_system) return t("scSystemModelOwner");
	return t("scModelOf").replace("{name}", model.owner?.name || "");
}

export function modelCountsText(model, t) {
	return t("scCounts")
		.replace("{domains}", model?.counts?.domains ?? 0)
		.replace("{exercises}", model?.counts?.exercises ?? 0);
}
